<template>
  <select v-model="operator" class="form-control">
    <option v-for="o in operators" :key="o.value" :value="o.value">
      {{ o.label }}
    </option>
  </select>
</template>

<script>
const operators = [
  { value: "equals", label: "Eşitse" },
  { value: "not_equals", label: "Eşit Değilse" },
  { value: "greater", label: "Büyükse" },
  { value: "less", label: "Küçükse" },
  { value: "in", label: "Seçtiğim varlıklardan herhangibiri ise" },
  { value: "not_in", label: "Seçtiğim varlıkların dışında ise" },
  { value: "some", label: "Arananlardan en az biri ile eşleşiyorsa" },
  { value: "not_some", label: "Arananlardan hiç biri ile eşleşmiyorsa" },
  { value: "every", label: "Arananların tümü ile eşleşiyorsa" },
  { value: "not_every", label: "Arananların tümü ile eşleşmiyorsa" },
  { value: "empty", label: "Boş ise" },
  { value: "not_empty", label: "Boş değil ise/Herhangi bir değer atanmışsa" },
];
export default {
  props: ["display", "selected"],
  data() {
    return {
      operators,
    };
  },
  computed: {
    operator: {
      get() {
        return this.selected;
      },
      set(op) {
        this.$emit("changed", op);
      },
    },
  },
  mounted() {
    this.setup(this.display);
  },
  watch: {
    display(allowed) {
      this.setup(allowed);
    },
  },
  methods: {
    setup(allowed) {
      if (!allowed) {
        return;
      }
      this.operators = operators.filter((o) => allowed.includes(o.value));
    },
  },
};
</script>
